module.exports = __webpack_public_path__ + "static/media/1019848.78895617.jpg";